import React, { FC, useContext, useEffect, useState } from 'react';
import { RecentlyViewedPropertiesContext } from '../../context/RecentlyViewedPropertiesContext';
import { useHasMounted } from '../../hooks/useHasMounted';
import { CardCarouselWrapper } from '../CardCarouselWrapper';
import { Divider } from '../Divider';
import { Section } from '../Section';
import Spacer from '../Spacer';
import { PropertyCard } from './PropertyCard';

interface RecentlyViewedPropertiesProps {
  divider?: boolean;
  usedIn?: string;
}

export const RecentlyViewedProperties: FC<RecentlyViewedPropertiesProps> = ({ divider, usedIn }) => {
  const { recentlyViewedProperties } = useContext(RecentlyViewedPropertiesContext);

  const hasMounted = useHasMounted();

  if (!hasMounted) {
    return null;
  }

  return (
    <>
      {recentlyViewedProperties && recentlyViewedProperties.length > 2 ? (
        <Section contained dontPrint overflowHidden>
          <Spacer responsive>
            {divider && <Divider />}
            <CardCarouselWrapper heading="Recently viewed properties">
              {recentlyViewedProperties.map((property) => (
                <PropertyCard
                  property={property}
                  vertical
                  onWhiteBg
                  key={`rv-${property.id}`}
                  unSaveable
                  prioritiseViewing
                  clickSection={usedIn}
                  displayMobileCta
                />
              ))}
            </CardCarouselWrapper>
          </Spacer>
        </Section>
      ) : (
        ''
      )}
    </>
  );
};

export default RecentlyViewedProperties;
